import React, { useEffect, useState } from 'react';
import { createPortal } from 'react-dom';
import { BOT_SRC } from './BotAvatar';

/** Total entrance duration must match CSS --bot-entrance-ms (1050ms). */
const ENTRANCE_MS = 1050;

/**
 * SaaS mascot entrance:
 * - Zoom-in pe peeche project UI heavy blur (readable nahi)
 * - Solid black/white fullscreen nahi — frosted blur only
 * - Mascot circle center pe zoom-in → overshoot → settle
 */
function BotIntroOverlay({ show, onDone }) {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    if (!show) {
      setVisible(false);
      return undefined;
    }

    const reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (reduced) {
      onDone?.();
      return undefined;
    }

    setVisible(true);
    const t = window.setTimeout(() => {
      setVisible(false);
      onDone?.();
    }, ENTRANCE_MS + 60);

    return () => window.clearTimeout(t);
  }, [show, onDone]);

  if (!show || !visible) return null;

  return createPortal(
    <div className="bot-entrance-root" aria-hidden>
      {/* Frosted blur of the project behind — not a solid black/white sheet */}
      <div className="bot-entrance-backdrop" />

      <div className="bot-entrance-stage-inner">
        <div className="bot-entrance-ring" />

        <div className="bot-entrance" anim="entrance">
          <div className="bot-entrance-fill">
            <img
              src={BOT_SRC}
              alt=""
              draggable={false}
              className="bot-entrance-img"
            />
          </div>
        </div>

        <span className="bot-sparkle bot-sparkle-1" aria-hidden>✦</span>
        <span className="bot-sparkle bot-sparkle-2" aria-hidden>✧</span>
        <span className="bot-sparkle bot-sparkle-3" aria-hidden>✦</span>
      </div>
    </div>,
    document.body,
  );
}

export default BotIntroOverlay;
